var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4132 21.4667L19.5465 17.6C20.9998 15.7333 21.7865 13.4533 21.7865 11.0533C21.7865 8.18666 20.6665 5.49333 18.6398 3.46666C14.4665 -0.720007 7.65318 -0.720007 3.47984 3.46666C-0.706823 7.65333 -0.706823 14.4533 3.47984 18.6267C5.50651 20.6533 8.19984 21.7733 11.0665 21.7733C13.4932 21.7733 15.7998 20.96 17.6665 19.4933L21.5332 23.36C21.7998 23.6267 22.1332 23.7467 22.4798 23.7467C22.8265 23.7467 23.1598 23.6133 23.4265 23.36C23.9465 22.84 23.9465 22 23.4265 21.48L23.4132 21.4667ZM5.35984 16.7467C2.21318 13.6 2.21318 8.49332 5.35984 5.35999C6.93318 3.78666 8.99984 2.99999 11.0532 2.99999C13.1065 2.99999 15.1732 3.78666 16.7465 5.35999C18.3198 6.93332 19.1065 8.90666 19.1065 11.0533C19.1065 13.2 18.2665 15.2267 16.7465 16.7467C15.2265 18.2667 13.1998 19.1067 11.0532 19.1067C8.90651 19.1067 6.87984 18.2667 5.35984 16.7467Z",
    fill: "#676A71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.64262e2e5bad1883554c8b69e22a8b43.svg";
export { ForwardRef as ReactComponent };